import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class SignatariosDocumentoAnexosApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async buscarSignatariosDocumentoAnexos(idDocumento) {
		return await axios.get(this.urlBuilder.signatarios.getUrlBuscarSignatariosDocumentoAnexos(idDocumento))
	}

	async convidarSignatariosDocumentoAnexos(idDocumento, emailsSignatarios) {
		return await axios.post(this.urlBuilder.signatarios.getUrlConvidarSignatariosDocumentoAnexos(idDocumento), {
			idDocumento,
			emailsSignatarios,
		})
	}

	async excluirSignatariosDocumentoAnexos(idDocumento, emailSignatario) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.signatarios.getUrlExcluirSignatariosDocumentoAnexos(idDocumento),
			filters: { emailSignatario, idDocumento },
		}).build()
		return await axios.delete(url)
	}
}

export default SignatariosDocumentoAnexosApiClient
